import React from 'react'

export type Props = {
  children: React.ReactNode
  url: string
}

export const NavigationLinkMobile = ({ children, url }: Props) => {
  return (
    <a
      className='mobile-navigation-button header-text-black-ultra header-px-5'
      href={url}
    >
      {children}
    </a>
  )
}
